import style from './style.module.css'

export default function Button({ children, onclick }){
    return (
        <button onClick={onclick} className={style.button + ' btn btn-default mt-5'}>{ children }</button>
    )
}